import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS
} from '../../../../AppDesigner/Elements';

const fields = {
  group: ELEMENT_GROUPS.TEXT,
  name: 'QRCode',
  label: 'QR Code',
  icon: 'DocumentTextIcon',
  description: 'Products a QR code from any data value',
  properties: [
    {
      label: 'QR Code Value',
      name: 'qrCodeValue',
      description:
        'Enter a value for this QR code. It can accept placeholders of the form {{it.someobject.field}}',
      editor: 'textbox',
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'QR Code Function',
      name: 'qrCodeFunction',
      editor: 'codeeditor',
      codeEditorHeight: '50vh',
      defaultLanguage: 'html',
      description:
        'You can provide a function instead of specific value. The function will be passed { local, data, user, documents, selections }. Simply return the value from the function that you want in the QR code.',
      displayWhen: [
        {
          field: 'qrCodeValue',
          operator: 'IS_EMPTY',
          value: ''
        }
      ],
      function: {
        name: '',
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    }
  ]
};

export default fields;
